import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Outlet, useLocation } from 'react-router';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Dropdown from 'react-bootstrap/Dropdown';
import NavItem from 'react-bootstrap/esm/NavItem';
import NavLink from 'react-bootstrap/esm/NavLink';
import Popover from 'react-bootstrap/Popover';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Button from 'react-bootstrap/Button';
import { CaretUpFill } from 'react-bootstrap-icons';
import banner from '../../assets/images/banner.jpg';
import { Logout } from '../login/Logout';
import { useContext, useState } from 'react';
// import AuthenticationEndpoint from '../../../api/endpoint/AuthenticationEndpoint';
import { SessionContext } from '../../context/SessionContext';

const main = {
    width: "100%",
    height: 'fit-content',
    marginTop:'70px',
    marginBottom: '70px',
    padding:'0.5em',
    flex: '1 0 auto'
} as const;

const navStyle = {
    boxShadow: "0 0 12px 0 rgba(0, 0, 0, 0.7)",
    backgroundColor: 'rgb(30, 99, 172)'
} as const;

const navLinkStyle = {
    color: "#d7e4ff"
} as const;

export const Front = () => {
    const [showLogout, setShowLogout] = useState(false);

    const sessionInfo = useContext(SessionContext);
    const sessionUser = sessionInfo?.user ? sessionInfo.user : null;

    const location = useLocation();
    
    const popover = (
        <Popover id="contact-popover">
            <Popover.Header as="h3">Contact Information</Popover.Header>
            <Popover.Body>
            <strong>Email </strong> ncast@weber.edu
            <br/>
            <strong>Phone </strong> (801) 389-3119
            </Popover.Body>
        </Popover>
    );


    return (
        <div>
            {showLogout &&
                <Logout show={showLogout} onHide={() => setShowLogout(false)}/>
            }
            <Navbar data-bs-theme="dark" className="fixed-top py-0" expand="lg" collapseOnSelect style={navStyle}>
                <Container fluid className='ms-0 me-2 p-0'>
                    <Navbar.Brand className='p-0'>
                        <img 
                            alt="VATTP banner"
                            src={banner}
                            height="70"
                            className="me-3 d-none d-sm-inline"
                        />
                        <span className="d-none d-xl-inline">Vermont Automotive Technician Training Program</span>
                        <span className="d-inline d-xl-none p-3">VATTP</span>
                        
                    </Navbar.Brand>
                    <Navbar.Toggle className="border-0" aria-controls="nav-collapse" />
                    <Navbar.Collapse id="nav-collapse">
                        <Nav className="me-auto nav-underline">
                            <Nav.Link href="#/" style={navLinkStyle}>Home</Nav.Link>
                            <Nav.Link href="#/available" style={navLinkStyle}>Available Courses</Nav.Link>
                            <Nav.Link href="#/upcoming" style={navLinkStyle}>Upcoming Courses</Nav.Link>
                            {sessionUser && sessionUser.user_role !== '' &&
                                <Dropdown as={NavItem} data-bs-theme="light" style={navLinkStyle} id="admin-dropdown">
                                    <Dropdown.Toggle as={NavLink} style={navLinkStyle}>Admin Tools</Dropdown.Toggle>
                                    <Dropdown.Menu className='shadow-sm'>
                                        <Dropdown.Item href="#/courses">Course List</Dropdown.Item>
                                        <Dropdown.Item href="#/events">Course Event List</Dropdown.Item>
                                        {sessionUser.user_role === 'Admin' &&
                                            <>
                                                <Dropdown.Item href="#/email">Email Tool</Dropdown.Item>
                                                <Dropdown.Item href="#/add-admin">Add Admin</Dropdown.Item>
                                                <Dropdown.Item href="#/users">User Management</Dropdown.Item>
                                            </>
                                        }
                                    </Dropdown.Menu>
                                </Dropdown>
                            }
                        </Nav>
                        <Nav>
                            {sessionUser && sessionUser.user_role !== '' &&
                                <Nav.Link style={navLinkStyle} onClick={() => setShowLogout(true)}>Log Out</Nav.Link>
                            }
                            {(!sessionUser || sessionUser.user_role == '') &&
                                <Nav.Link style={navLinkStyle} href="#/login">Admin Login</Nav.Link>
                            }
                        </Nav>
                    </Navbar.Collapse>
                    
                    
                </Container>
            </Navbar>
            <main tabIndex={-1} id="main-content" style={main}>
                <Row>
                    <Col xs={0} md={1}/>
                    {location.pathname !== '/' &&
                        <>
                            <Col xs={12} md={10}>
                                <Outlet />
                            </Col>
                            
                            <Col xs={0} md={1} />
                        </>
                    }

                    {location.pathname === '/' &&
                        <>
                            <Col xs={12} md={10}>
                                <Outlet />
                            </Col>
                            <Col />
                        </>
                    }
                </Row>
                
            </main>
            <footer className="fixed-bottom">
                <Container fluid className="px-5 py-2 text-center bg-body-tertiary text-body-secondary d-none d-sm-block">
                    <Row >
                        <Col>Contact Email: ncast@weber.edu</Col>
                        <Col>Contact Phone: (801) 389-3119</Col>
                        <Col>Copyright © 2024 NCAST All Rights Reserved</Col>
                    </Row>
                </Container>
                <Container fluid className="d-block d-sm-none bg-body-tertiary text-body-secondary">
                    <Row>
                        <Col xs={4}>
                            <OverlayTrigger trigger="click" placement="top" overlay={popover}>
                                <Button className="text-body-secondary" style={{fontSize:'1em', margin:'0', padding:'0', backgroundColor:'transparent', border:'0'}}>Contact <CaretUpFill size={12}/></Button>
                            </OverlayTrigger>
                        </Col>
                        <Col xs={8} style={{fontSize:'0.8em', paddingTop:'5px', textAlign:'right'}}>Copyright © 2024 NCAST All Rights Reserved</Col>
                    </Row>
                </Container>
            </footer>
            
        </div>
    )
}